import { render, staticRenderFns } from "./acctManagerDc.vue?vue&type=template&id=5bd08c79&scoped=true"
import script from "./acctManagerDc.vue?vue&type=script&lang=js"
export * from "./acctManagerDc.vue?vue&type=script&lang=js"
import style0 from "./acctManagerDc.vue?vue&type=style&index=0&id=5bd08c79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd08c79",
  null
  
)

export default component.exports